<template>
  <section class="w-full bg-white">
    <!-- <h1 class="text-transpurple font-bold text-48 text-center leading-73">
      Cases by States
    </h1> -->
    <div class="flex items-center">
      <div class="dropdown ml-auto mb-4 xl:mt-0 mr-4">
        <select
          v-model="status_key"
          class="p-2 dropdown-toggle w-40 button font-normal border dark:border-dark-5 text-white dark:text-gray-300 relative flex items-center text-gray-700"
          @change="getStatesCount()"
        >
          <option value="">Filter by Status</option>
          <option
            v-for="(item, key) in status_params"
            :key="key"
            :value="item.key"
            class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
            >{{ item.value }}</option
          >
        </select>
      </div>
      <div class="mb-4 xl:mt-0">
        <DownloadChart
          @click="downloadCanvas('casesStateChart', 'titleStatesChart')"
        />
      </div>
    </div>
    <div ref="casesStateChart">
      <h3 ref="titleStatesChart" class="hidden mt-4 text-lg">
        Corruption Cases By State
      </h3>
      <BarChart :chart-data="chartdata" :options="options" />
    </div>
  </section>
</template>

<script>
import BarChart from "./Charts/BarChart";
// import HorizontalBar from "./Charts/HorizontalBar";
import axios from "axios";

export default {
  name: "CasesStateChart",
  components: {
    BarChart
  },
  data() {
    return {
      state_counts: [],
      status_params: [],
      status_key: ""
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    counts() {
      return this.state_counts.map(a => a.cases_count);
    },
    names() {
      return this.state_counts.map(a => a.name);
    },
    chartdata() {
      return {
        labels: this.names,
        datasets: [
          {
            label: "Cases by State",
            backgroundColor: "#133050",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.counts
          }
        ]
      };
    },
    options() {
      return {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems) {
              return tooltipItems.yLabel;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getStatesCount();
      }
    }
  },
  mounted() {
    this.getStatusParams();
    this.getStatesCount();
  },
  methods: {
    getStatesCount() {
      let url = `${window.host}/api/statescount/5`;
      if (this.status_key) url += `?status[]=${this.status_key}`;

      axios
        .get(url, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.state_counts = response.data;
          }
        });
    },
    getStatusParams() {
      axios.get(`${window.host}/api/statuses-params`).then(response => {
        if (response.data) this.status_params = response.data;
      });
    }
  }
};
</script>

<style scoped>
section {
  .svg {
    width: 100vw;
  }
}
</style>
